import React, {
  Suspense,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import { Link } from "react-router-dom";
import { getTrans as T } from "../../../Shared/Language";
import { getLeaveDetailsList, withdrwalLeaveStatus } from "./leaveService";
import TosterService from "../../../Services/Toster-Service/TosterService";
import { TostMsg } from "../../../App";
import {
  GetMasterSystemAlert,
  orgSettings,
} from "../../../Services/Global-Services/GlobalServices";
import LeaveNavBarItems from "./CommonComponents/LeaveNavBarItems";
import LeaveManagerReport from "./CommonComponents/LeaveManagerReport";
import { Paginator } from "primereact/paginator";
import { LazyImage } from "../../../Services/Decorator_Lazy_Loading/ImageVideoLazyLoding";
import moment from "moment";
import ERROR_LIST from "../../../Services/Global-Services/Hadle_Errors";
const ComponentLoader = React.lazy(() =>
  import("../../../Shared/Sidebar/ComponentLoader")
);

function MyLeaveCompletedLeave() {
  const [completeLeaveData, setCompleteLeaveData] = useState([]);
  const toster = useContext(TostMsg);
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const [showAllUserDataModel, setshowAllUserDataModel] = useState([]);
  const [resonValue, setResonValue] = useState("");
  const [masterSystemAlertData, setMasterSystemAlertData] = useState([]);
  const [Isloading, setIsloading] = useState(false);
  let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "{}");
  const ResontextStyle = {
    maxWidth: "100%",
    display: "-webkit-box",
    WebkitBoxOrient: "vertical",
    WebkitLineClamp: 1,
    overflow: "hidden",
    textOverflow: "ellipsis",
    cursor: "pointer",
  };
  const [showLeaveHistory, setShowLeaveHistory] = useState(null);
  const [inputType, setInputType] = useState("date");
  const [empIdHierechy, setEmpIdHierechy] = useState(userDetails?.EmpId);
  const [totalRecords, setTotalRecords] = useState(0);
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);
  const [pageNumber, setPageNumber] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  let Sdate = null;
  let EDate = null;
  const [filterStartDate, setFilterStartDate] = useState(Sdate);
  const [filterEndDate, setFilterEndDate] = useState(EDate);
  useEffect(() => {
    OrgSettings();
  }, []);

  async function OrgSettings() {
    let param = {
      OrgId: userDetails?.OrgId,
    };
    try {
      let responce = await orgSettings(param);
      let StartDate = responce?.Data?.filter(
        (element) => element.KeyName == "LeaveFilterStartDate"
      );
      if (StartDate[0]?.Value != null) {
        Sdate = new Date(StartDate[0]?.Value)?.toISOString()?.split('T')[0];
      } else {
        Sdate = new Date(new Date() - 30 * 24 * 60 * 60 * 1000)
          ?.toISOString()
          ?.split("T")[0];
      }
      setFilterStartDate(Sdate);
      let EndDate = responce?.Data?.filter(
        (element) => element?.KeyName == "LeaveFilterEndDate"
      );
      if (EndDate[0]?.Value != null) {
        EDate = new Date(EndDate[0]?.Value)?.toISOString()?.split("T")[0];
      } else {
        EDate = new Date()?.toISOString()?.split("T")[0];
      }
      setFilterEndDate(EDate);
      if (Sdate && EDate && empIdHierechy) {
        getLeaveData(pageNumber, pageSize);
      }
    } catch (error) {
      Sdate = new Date(new Date() - 30 * 24 * 60 * 60 * 1000)
        ?.toISOString()
        ?.split("T")[0];
      EDate = new Date()?.toISOString()?.split("T")[0];
      setFilterStartDate(Sdate);
      setFilterEndDate(EDate);
      setIsloading(false);
    }
  }

  const getLeaveData = async (pageNumber, pageSize) => {
    let FilterendOfTheDay = new Date(filterEndDate);
    FilterendOfTheDay?.setUTCHours(23, 59, 59, 999);
    const FilterEndDate = FilterendOfTheDay?.toISOString();
    const param = {
      OrgId: userDetails?.OrgId,
      LoggedInEmpId: userDetails?.EmpId,
      EmpId: empIdHierechy,
      LeaveId: 0,
      leavecategory: "C",
      HierarchyTypeId: 1,
      FilterStartDate: new Date(filterStartDate).toISOString() ?? Sdate,
      FilterEndDate: FilterEndDate,
      pageNumber: pageNumber,
      pageSize: pageSize,
    };
    try {
      setIsloading(true);
      const data = await getLeaveDetailsList(param);
      let leaveDetailData = data;
      setCompleteLeaveData(leaveDetailData?.Data);
      setTotalRecords(leaveDetailData?.Data[0]?.TotalCount);
      setIsloading(false);
    } catch {
      setIsloading(false);
      toster.current.error(ERROR_LIST.DefaultError);
    }
  };

  useEffect(() => {
    getLeaveData(pageNumber, pageSize);
  }, [filterStartDate, filterEndDate]);

  const handleResonChange = (e) => {
    setResonValue(e.target.value);
  };
  const handleWithdrwalSubmit = async (submitType) => {
    if (submitType == "Withdrwal") {
      setIsloading(true);
      const body = {
        id: showAllUserDataModel?.Id ?? 0,
        RequestorId: userDetails?.EmpId,
        Reason: resonValue ?? "",
      };
      try {
        await withdrwalLeaveStatus(body);
        getLeaveData(pageNumber, pageSize);

        GetMasterSystemAlertList("Status_Updated", 0);
        setResonValue("");
        setshowAllUserDataModel([]);
        setIsloading(false);
        document.getElementById("pending-request").click();
      } catch (err) {
        toster.current.warn(err?.Message);

        setIsloading(false);
        document.getElementById("pending-request").click();
      }
    }
  };

  const GetMasterSystemAlertList = useCallback(async (message, type) => {
    SystemAlerts?.filter((msg) => {
      if (msg?.Name == message && type == 0) {
        toster.current.success(msg?.Desc);
      } else if (msg?.Name == message && type == 1) {
        setMasterSystemAlertData(msg?.Desc);
      } else if (msg?.Name == message && type == 2) {
        setMasterSystemAlertData(msg?.Desc);
      }
    });
  }, []);

  const handleToggle = (index) => {
    if (showLeaveHistory === index) {
      setShowLeaveHistory(null);
    } else {
      setShowLeaveHistory(index);
    }
  };

  const applyFilterData = () => {
    getLeaveData(pageSize, pageNumber);
  };
  const onPageChange = async (event) => {
    setFirst(event.first);
    setRows(event.rows);
    await getLeaveData(event.page, event.rows);
  };

  useEffect(() => {
    if (masterSystemAlertData?.length > 0) {
      toster.current.success(masterSystemAlertData);
    }
  }, [masterSystemAlertData]);

  return (
    <div>
      <div id="circular-menu" className="circular-menu">
        <a className="floating-btn">
          <i aria-hidden="true" className="fa fa-cog fa-spin"></i>
          <i aria-hidden="true" className="fa fa-times"></i>
        </a>

        <div className="items-wrapper">
          <div className="menu-item is-flex">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </div>
          <a
            className="menu-item is-flex right-panel-trigger"
            data-panel="languages-panel"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </a>
          <Link to="" className="menu-item is-flex">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-bell"
            >
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
              <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
            </svg>
          </Link>
          <a
            className="menu-item is-flex right-panel-trigger"
            data-panel="activity-panel"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-grid"
            >
              <rect x="3" y="3" width="7" height="7"></rect>
              <rect x="14" y="3" width="7" height="7"></rect>
              <rect x="14" y="14" width="7" height="7"></rect>
              <rect x="3" y="14" width="7" height="7"></rect>
            </svg>
          </a>
        </div>
      </div>
      <div className="container-fluid position-relation">
            <div className="row g-3">
              <div className="form-head mb-3">
                 <div className="row">
                      <div className="col-lg-5">
                          <div className="">
                            <h2 className="font-w600 mb-0">{T("Leaves")}</h2>
                          </div>
                      </div>
                      <div className="col-lg-7">
                            <LeaveNavBarItems />
                      </div>
                  </div>
              </div>
          <div className="col-xl-8">
            <div className="leave-card tile-grid tile-grid-v1">
              <div className="card">
                <div className="tab-tabsa">
                  <div className="div">
                    <Link to="/Leave">
                      <h2 className="font-w600 mb-0">Upcoming</h2>
                    </Link>
                  </div>
                  <div className="div">
                    <Link to="/MyLeaveCompletedLeave">
                      <h2 className="font-w600 mb-0 h2active">Archived</h2>
                    </Link>
                  </div>
                  <div className="div">
                    <Link to="/MyLeavePendingLeave">
                      <h2 className="font-w600 mb-0">Pending</h2>
                    </Link>
                  </div>
                  <div className="div side-filter">
                    {/* {isFilterVisible && ( */}
                    <div className="filter-down">
                      <div className="tab-tabsa1">
                        <div className="form-group d-gridcss">
                          <label>Start Date</label>
                          <input
                            type={inputType}
                            name="startDate"
                            className="form-control"
                            placeholder="Start Date"
                            onFocus={() => setInputType("date")}
                            onBlur={() => setInputType("text")}
                            value={filterStartDate}
                            onChange={(e) => setFilterStartDate(e.target.value)}
                          />
                          <label>End Date</label>
                          <input
                            type={inputType}
                            name="endDate"
                            className="form-control"
                            placeholder="End Date"
                            onFocus={() => setInputType("date")}
                            onBlur={() => setInputType("text")}
                            value={filterEndDate}
                            onChange={(e) => setFilterEndDate(e.target.value)}
                          />
                        </div>
                        <div className="apply-filter d-none">
                          <a onClick={() => applyFilterData()}>
                            <img src="images/org-img/leave/filter-search.svg" />
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {completeLeaveData?.map((leave, index) => {
                return (
                  <div className="card bottom-card">
                    <div className="card-body">
                      <div className="row" key={index}>
                        <div className="my-leavecard-list">
                          <div className="leave-container">
                            <img
                              src="images/org-img/leave/upcoming1.png"
                              className="w-100  leave-image"
                            />
                            <div className="leave-count-overlay">
                              {leave?.Days}
                            </div>
                          </div>
                          <div className="innerdiv d-flex align-items-center">
                            <div className="media-body px-0">
                              <span className="mt-0 mb-3 datecol">
                                {" "}
                                {leave?.LeaveTypeName}
                              </span>
                              <h6 className="mb-0">
                                <a
                                  className="text-black"
                                  style={ResontextStyle}
                                  title={leave?.Reason}
                                >
                                  {leave?.Reason}.
                                </a>
                              </h6>
                            </div>
                          </div>
                          <div className="innerdiv d-flex align-items-center">
                            <div className="d-flex">
                              <p className="me-2 mb-0">
                                <b>From </b>:{" "}
                                 {moment(leave?.StartDate).format("MMM DD YYYY")}                                
                              </p>
                              <p className="me-2 mb-0">
                                <b>To </b>:
                                 {moment(leave?.EndDate).format("MMM DD YYYY")} 
                              </p>
                              <p className="mb-0">
                                <b>Half Day </b>:{" "}
                                {leave?.IsHalfDay == false && <span>No</span>}{" "}
                                {leave?.IsHalfDay == true && <span>Yes</span>}
                              </p>
                            </div>
                          </div>
                          <div className="innerdiv d-flex align-items-center">
                            {leave?.LeaveStatusId === 103 && (
                              <a className="approved-status-btn">
                                <i
                                  className="fa fa-clock-o"
                                  aria-hidden="true"
                                ></i>{" "}
                                {leave?.LeaveStatusName}
                              </a>
                            )}
                            {leave?.LeaveStatusId != 103 && (
                              <a className={leave?.LeaveStatusName}>
                                <i
                                  className="fa fa-clock-o"
                                  aria-hidden="true"
                                ></i>{" "}
                                {leave?.LeaveStatusName}
                              </a>
                            )}
                            {leave?.LeaveStatusId != 103 && (
                              <a
                                className="withdraw-status-btn"
                                data-bs-toggle="modal"
                                data-bs-target="#pending-request"
                                onClick={() => {
                                  setshowAllUserDataModel(leave);
                                }}
                              >
                                <i
                                  className="fa fa-clock-o"
                                  aria-hidden="true"
                                ></i>{" "}
                                Withdraw
                              </a>
                            )}
                          </div>

                          <div
                            className="innerdiv show-more"
                            onClick={() => handleToggle(index)}
                          >
                            {showLeaveHistory === index ? (
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                className="bi bi-chevron-down"
                                viewBox="0 0 16 16"
                              >
                                <path
                                  fillRule="evenodd"
                                  d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
                                />
                              </svg>
                            ) : (
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                className="bi bi-chevron-up"
                                viewBox="0 0 16 16"
                              >
                                {" "}
                                <path
                                  fillRule="evenodd"
                                  d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708z"
                                />
                              </svg>
                            )}
                          </div>
                        </div>
                        {showLeaveHistory === index && (
                          <div className="my-leavedetail-view">
                            {leave?.EmpLeaveHistory?.length > 0 ? (
                              leave?.EmpLeaveHistory?.reverse()?.map(
                                (history, Hindex) => (
                                  <div key={history?.Id}>
                                    <ul className="timeline" key={Hindex}>
                                      <li className="timeline-inverted">
                                        <div className="timeline-badge">
                                          {Hindex + 1}
                                        </div>
                                        <div className="timeline-panel">
                                          <div className="flex-container flex-around">
                                            <div className="timeline-heading">
                                              <h4 className="timeline-title">
                                                {history?.CreatedByName}
                                              </h4>
                                              <p className="timeline-title">
                                                {history?.Comments}
                                              </p>
                                              <h5 className="leavestatus-timeline">
                                                <i
                                                  className="fa fa-clock-o"
                                                  aria-hidden="true"
                                                ></i>
                                                {history?.LeaveStatusName}
                                                <span>
                                                  On{" "}
                                                   {moment(history?.ModifiedDate).format("MMM DD YYYY")}
                                                </span>
                                              </h5>
                                            </div>
                                          </div>
                                        </div>
                                      </li>
                                    </ul>
                                  </div>
                                )
                              )
                            ) : (
                              <div>No Leave History Found.</div>
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                );
              })}
              {completeLeaveData?.length === 0 ||
              completeLeaveData?.length == null ? (
                <div className="no-data">
                  <img src="/images/no-data-found/No_leave.png" />
                  <p>No Data Found.</p>
                </div>
              ) : (
                <div className="card pagination-css">
                  <Paginator
                    first={first}
                    rows={rows}
                    totalRecords={totalRecords}
                    rowsPerPageOptions={[10, 20, 30]}
                    onPageChange={onPageChange}
                  />
                </div>
              )}
            </div>
          </div>
          <div className="col-xl-4">
            <div className="row sidecarddd">
              <div className="col-xl-12">
                <LeaveManagerReport />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="modal fade" id="pending-request">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content withdrawleave">
            <div className="modal-header">
              <img
                src="/images/org-img/leave/popup-backimg.png"
                className="backimg"
              />
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
              ></button>
              <div className="img">
                <img src="/images/org-img/leave/withdrawal.png" />
              </div>
            </div>
            <form onSubmit={handleWithdrwalSubmit}>
              <div className="modal-body text-center">
                <strong className="modal-title d-block">
                  Withdrawal Request
                </strong>

                <div className="inner">
                  <div className="h-avatar">
                    <LazyImage
                      className="avatar"
                      src={userDetails?.ProfileImage}
                      alt={userDetails?.FullName}
                    />
                  </div>
                  <div className="para-detail">
                    <span className="name-p">
                      {showAllUserDataModel?.EmployeeName}
                    </span>
                    applied
                    <span>
                      <b>From </b>-
                       {moment(showAllUserDataModel?.StartDate).format("MMM DD YYYY")}   
                    </span>
                    <span>
                      <b>To </b>-
                       {moment(showAllUserDataModel?.EndDate).format("MMM DD YYYY")}                        
                    </span>
                    <span>
                      with
                      {showAllUserDataModel.IsHalfDay == false && (
                        <span>No</span>
                      )}{" "}
                      {showAllUserDataModel.IsHalfDay == true && (
                        <span>Yes</span>
                      )}
                      <b> Half Day </b>
                    </span>
                  </div>
                </div>
                <label className="mt-3">Reason</label>
                <textarea
                  rows="2"
                  cols="1"
                  className="form-control"
                  value={resonValue}
                  onChange={handleResonChange}
                  placeholder="Reason"
                ></textarea>
              </div>
            </form>
            <div className="modal-footer m-auto">
              <button
                type="button"
                className="cancelbtn-click"
                data-bs-dismiss="modal"
              >
                cancel
              </button>
              <button
                type="button"
                onClick={() => handleWithdrwalSubmit("Withdrwal")}
                className="savebtn-click"
              >
                Accept
              </button>
            </div>
          </div>
        </div>
      </div>

      <TosterService ref={toster} />
      {Isloading ? (
        <Suspense >
          <ComponentLoader />
        </Suspense>
      ) : (
        ""
      )}
    </div>
  );
}

export default MyLeaveCompletedLeave;
